import i18n from '@/i18n';

const t = (key: string) => i18n.global.t(key);

export default (_ctx?: any) => (
  [
    {
      title: t('Campaigns'),
      value: 'campaigns',
      fieldName: 'campaigns-name',
      data: <any[]> [],
    },
    {
      title: t('Traffic sources'),
      value: 'traffic-sources',
      fieldName: 'traffic_sources-name',
      data: <any[]> [],
    },
    {
      title: t('Countries'),
      value: 'countries',
      fieldName: 'reports-country',
      data: <any[]> [],
    },
    {
      title: t('Offers'),
      value: 'offers',
      fieldName: 'offers-name',
      data: <any[]> [],
    }
  ]
);